// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var WebAnalyticsLogo = function WebAnalyticsLogo(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M4.6 6.769h-.869A.434.434 0 003.3 7.2v1.74a.434.434 0 00.434.434H4.6a.434.434 0 00.434-.434V7.2a.434.434 0 00-.434-.431zM7.2 5.9h-.865a.4.4 0 00-.434.348v2.779a.4.4 0 00.434.347H7.2a.4.4 0 00.434-.347V6.249A.4.4 0 007.2 5.9zM9.808 4.165H8.94a.406.406 0 00-.434.372V9a.406.406 0 00.434.372h.868A.406.406 0 0010.242 9V4.537a.406.406 0 00-.434-.372z"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M15.839 15.064L11.8 11.027a6.11 6.11 0 10-.776.776l4.037 4.036a.548.548 0 00.775-.775zm-8.722-2.939a5.008 5.008 0 115.008-5.008 5.009 5.009 0 01-5.008 5.008z",
      opacity: ".5"
    }))
  );
};

export default WebAnalyticsLogo;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/WebAnalyticsLogo.js
// module id = 1062
// module chunks = 0